import api from '@/api';

// Used inside the components/ContentList and componenents/new-site/content-header.
const SaveToList = () => {
    return {
        content: undefined,
        listsOptionsOpened: false,
        isDraft: false,
        lists: [],
        loading: false,

        init(){
            document.addEventListener('savedList.saved', (event) => this.handleCreatedList(event.detail));

            this.$watch('listsOptionsOpened', value => {
                if(value){
                    this.$dispatch('disable-scroll')

                    return;
                }

                this.$dispatch('enable-scroll')
            });

            this.$watch('isDraft', value => {
                this.$dispatch('set-content-on-create-list', { content: value ? this.content.id : null });
            });
        },

        async toggleContentToList(content, list){
            let isActive = this.lists.some((currentList) => currentList === list.id);

            this.loading = true;

            await api.post('/update-list', { list: list.id, content: content.id })
                .then(({ data }) => {
                    const { attached } = data;

                    this.handleUpdateSelectedLists({ content, selectedLists: this.lists });

                    isActive = attached;
                })
                .finally(() => {
                    this.loading = false;
                });

            isActive && trackEvent('content_save', 'Content', content.slug, { content_slug: content.slug });
        },

        handleCreatedList({ savedList }){
          this.lists.push(savedList.id);

          this.availableLists.push(savedList);

          this.handleUpdateSelectedLists({ content: this.content, selectedLists: this.lists });

          trackEvent('content_save', 'Content', this.content.slug, { content_slug: this.content.slug });

          this.isDraft = false;
        },

        handleUpdateSelectedLists({ content, selectedLists } = {}){
            this.$dispatch('updated-selected-lists', { content, selectedLists });

            this.content.selectedLists = this.availableLists.filter((availableLists) => selectedLists.indexOf(availableLists.id) >= 0)
        },
    }
}

export default SaveToList;
